import { mergeStyleSets } from '@uifabric/merge-styles';
import { IconButton, Stack } from 'office-ui-fabric-react';
import React, { Component } from 'react';
import LogoEiffage from '../images/logo-Eiffage.png';

/*
****************************************************************************************************************
PROPS :
    ATTRIBUTS :
        string  titre                   titre du panel
    METHODES :
        void    onClose                 appel�e pour la fermeture du panel
****************************************************************************************************************
*/

class Header extends Component {

    _classNames = mergeStyleSets({
        image: {
            borderRadius: "50%",
            height: "60px",
            padding: "10px",
            width: "60px"
        }
    });

    _styles = {
        root: {
            root: {
                background: "#ff0000",
                boxShadow: "0 1px 4px rgba(0, 0, 0, .2)",
                color: "white",
                minHeight: "75px",
                padding: "10px",
            }
        },
        title: { root: { fontSize: "20px" } },
    }

    render = () => {
        return <Stack horizontal verticalAlign="center" gap={10} styles={this._styles.root}>
            <img className={this._classNames.image} src={LogoEiffage} alt="Logo Eiffage" />
            <Stack.Item grow styles={this._styles.title}>{this.props.titre}</Stack.Item>
            <IconButton
                ariaLabel="Masquer la conversation"
                iconProps={{ iconName: "ChromeClose", styles: { root: { color: "white" } } }}
                onClick={this.props.onClose}
                title="Masquer la conversation"
            />
        </Stack>
    }
}

export default Header;
